import { useMemo } from "react";

import { getTrainersTeam } from "@fitness-app/app-store/src/store/reducers/team/selectors";
import { TeamMemberRole, TeamMemberStatus } from "@fitness-app/data-models";

import { useAppSelector } from "~/store/initializeStore";

// Assignee / mention candidates: active board-role team members (approximates
// support_is_staff(), which is permission-based: support.manage — SALES_REP is
// the only baseline without it). The server re-validates, this only feeds the
// pickers.
const BOARD_ROLES: string[] = [
  TeamMemberRole.ACCOUNT_OWNER,
  TeamMemberRole.ADMINISTRATION,
  TeamMemberRole.SHARED_TRAINER,
  TeamMemberRole.REGULAR_TRAINER,
  TeamMemberRole.SUPPORT,
];

export interface SupportStaffMember {
  userId: string;
  name: string;
  avatarUrl: string | null;
}

export const useSupportStaff = () => {
  const team = useAppSelector(getTrainersTeam);

  return useMemo(() => {
    const byUserId = new Map<string, SupportStaffMember>();

    for (const member of team || []) {
      if (
        !member.userId ||
        member.disabled ||
        member.status !== TeamMemberStatus.ACTIVE ||
        !BOARD_ROLES.includes(member.role)
      ) {
        continue;
      }
      if (byUserId.has(member.userId)) {
        continue;
      }
      byUserId.set(member.userId, {
        userId: member.userId,
        name: [member.firstName, member.lastName].filter(Boolean).join(" ") || member.email || member.userId,
        avatarUrl: member.user?.avatarUrl || null,
      });
    }

    return { staff: [...byUserId.values()], staffByUserId: byUserId };
  }, [team]);
};
